import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Oidc from 'oidc-client';
import withUserData from 'hoc/withUserData';
import { refreshKyClientAccessToken } from 'services/client';

//Identity server needs this page to call back to in order to complete its sign in process
const LoginCallback = (props) => {
  const { userData } = props;
  const history = useHistory();

  useEffect(() => {
    (async () => {
      try {
        await new Oidc.UserManager({
          clockSkew: 86400,
        }).signinRedirectCallback();
        await refreshKyClientAccessToken();
        history.push(userData.currentPath || '/');
      } catch (e) {
        console.error(e);
        history.push('/ErrorPage');
      }
    })();
  }, [userData.currentPath, history]);
  return null;
};

LoginCallback.propTypes = {
  userData: PropTypes.object, //from withUserData HOC
};

export default withUserData(LoginCallback);
